import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Table, Row, Col, Breadcrumb, Typography, Modal, Tooltip } from 'antd';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../common_functions';
const Prints = props => {
  const [collections, setCollections] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Print condition',
      dataIndex: 'condition',
      key: 'condition',
      sorter: true,
      ...filter('condition'),
    },
    {
      title: 'Print Condition Description',
      dataIndex: 'desc',
      key: 'desc',
      sorter: true,
      ...filter('desc'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/prints-conditions/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_prints_conditions?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_prints_conditions?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'print_condition',
              'Print condition rating?',
              collections,
              setCollections,
              props?.tabs_permissions?.settings_prints_conditions?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  useEffect(() => {
    (async () => {
    if (props.roleType == 'admin' || !!props.tabs_permissions.settings_prints_conditions.view) {
      await getPrintConditions(pagination);
    }
  })();
  }, []);

  const getPrintConditions = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('print_condition', {
        fields: ['id', 'condition', 'desc'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setCollections(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (var key in filters) {
      if (filters.hasOwnProperty(key)) {
        var val = filters[key];
        if (val) {
          filtersitems[key] = { _icontains: val[0] };
        }
      }
    }
    await getPrintConditions(pagination, filtersitems, sorter);
  };

  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/prints-conditions" }, { title: "Print condition rating" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Print condition rating
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_prints_conditions,
                '/settings/prints-conditions/new',
                'Create Print Condition Rating'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={collections}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Prints;
